import { combineReducers } from 'redux';
import userReducer from './userReducer';
import tokenReducer from './tokenReducer';

import prospectReducer from './prospectReducer';

import utilReducer from './utilReducer';

import ConversationsReducer from './conversationReducer';

import ResponsiveReducer from './responsiveReducer';

export default combineReducers({
  user: userReducer,
  token: tokenReducer,
  prospects: prospectReducer,
  utils: utilReducer,
  conversation: ConversationsReducer,
  responsive: ResponsiveReducer,
});
